// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__0ghjI","placeholder":"styles_placeholder__NEXRE"};